import { Icon, Typography } from '@/components';
import { cn } from '@/utils/styles';

import { CardType } from './types';

export function HeaderCard({ icon, title, value, className, asGroup = true }: CardType) {
  return (
    <div className={cn('flex items-start gap-3', className)}>
      <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-neutral-100">
        <Icon name={icon} className="h-5 w-5 text-neutral-700" />
      </div>
      <div className="flex min-w-0 flex-col">
        <Typography as="p" size="body-3" color="secondary" weight="medium" className="mb-1">
          {title}
        </Typography>
        <Typography as="p" size="body-2" color="primary" weight="semibold" className="break-words">
          {value}
        </Typography>
      </div>
    </div>
  );
}
